import * as React from 'react';
import { View } from 'react-native';
import Text from 'design-system/Text';
import Spacer from 'design-system/Spacer';
import { CardView } from 'design-system/CardView';
import IconInfoTriangle from 'design-system/icons/IconInfoTriangle';
import useStyles from 'hooks/useStyles';
import { useAppSelector } from 'store/hooks';
import createStyleSheets from 'utils/createStyleSheets';
import { formatBuyBlock } from '../utils/format';
import { selectTradingAccount } from '../reducers/selectors';
const BuyBlockView = () => {
    const styles = useStyles(styleSet);
    const tradingAccount = useAppSelector(selectTradingAccount);
    const tradingBlockExpiryDate = tradingAccount?.account.tradingBlockExpiryDate;
    if (!tradingBlockExpiryDate) {
        return null;
    }
    return (<CardView style={styles.container} withPadding noMarginTop noMarginBottom>
      <IconInfoTriangle colorKey="brand"/>
      <Spacer w={8}/>
      <View style={styles.textContainer}>
        <Text TextThin-14 Primary>
          {`You can’t buy any shares since you have a buy block enabled. This expires on ${formatBuyBlock(tradingBlockExpiryDate)}.`}
        </Text>
      </View>
    </CardView>);
};
export default React.memo(BuyBlockView);
const styleSet = createStyleSheets((colors) => ({
    container: {
        alignItems: 'center',
        flexDirection: 'row',
        backgroundColor: colors.background.brandLight,
    },
    textContainer: {
        flex: 1,
    },
}));
